import { render } from "./CreateStafetProfile.vue?vue&type=template&id=be3178b4"
import script from "./CreateStafetProfile.vue?vue&type=script&lang=js"
export * from "./CreateStafetProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__